import React from 'react';

export const GstIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export const ItrIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22V12" />
    <path d="M5 12H2a10 10 0 0 0 20 0h-3" />
    <path d="M12 2a10 10 0 0 1 7.39 3.19" />
    <circle cx="12" cy="7" r="1" />
    <path d="M12 2v5" />
    <line x1="12" y1="8" x2="12" y2="12" />
  </svg>
);

export const ShopIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);

export const RentIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
    <path d="M10 13v4" />
  </svg>
);

export const LoanIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

export const UdyamIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 7h16v10H4z" />
    <path d="M8 7v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M8 12h8" />
    <circle cx="12" cy="16" r="1.5" />
  </svg>
);

export const FoodIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7h18" />
    <path d="M8 7v10a4 4 0 0 0 8 0V7" />
    <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    <path d="M12 11v6" />
    <path d="M10 17h4" />
  </svg>
);

export const ProjectIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1b9fcf" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 3h10l6 6v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
    <path d="M14 3v6h6" />
    <rect x="6" y="10" width="6" height="4" rx="0.5" />
    <path d="M6 16h8" />
    <path d="M8 12v4" />
  </svg>
);
